
import { Card } from "@/components/ui/card";
import { TestQuestion } from "./TestQuestion";
import { TestProgress } from "./TestProgress";
import { TestNavigation } from "./TestNavigation";
import { Answer } from "@/types/test";

interface TestContainerProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  currentQuestion: any;
  currentAnswer?: Answer;
  isSubmitting: boolean;
  ageCategory?: string;
  category?: string;
  stage?: string;
  onAnswerSelect: (questionId: number, answerIndex: number, value?: string) => void;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

export const TestContainer = ({
  currentQuestionIndex,
  totalQuestions,
  currentQuestion,
  currentAnswer,
  isSubmitting,
  ageCategory,
  category,
  stage,
  onAnswerSelect,
  onPrevious,
  onNext,
  onSubmit,
}: TestContainerProps) => {
  console.log("Current question in container:", currentQuestion); // Debug log
  console.log("Total questions:", totalQuestions); // Debug log
  console.log("Current question index:", currentQuestionIndex); // Debug log

  return (
    <Card className="max-w-3xl mx-auto">
      <div className="p-6 space-y-6">
        {(ageCategory || category || stage) && (
          <div className="space-y-2 mb-4">
            {ageCategory && (
              <h2 className="text-xl font-semibold text-primary">
                {ageCategory}
              </h2>
            )}
            {category && (
              <h3 className="text-lg font-medium text-muted-foreground">
                {category}
              </h3>
            )}
            {stage && (
              <h4 className="text-md text-muted-foreground">
                {stage}
              </h4>
            )}
          </div>
        )}
        
        <TestProgress
          currentQuestionIndex={currentQuestionIndex}
          totalQuestions={totalQuestions}
        />

        {currentQuestion ? (
          <>
            <TestQuestion
              key={currentQuestion.id}
              question={currentQuestion}
              selectedAnswer={currentAnswer?.index}
              onAnswerSelect={onAnswerSelect}
            />

            <TestNavigation
              currentQuestionIndex={currentQuestionIndex}
              totalQuestions={totalQuestions}
              hasCurrentAnswer={!!currentAnswer}
              isSubmitting={isSubmitting}
              onPrevious={onPrevious}
              onNext={onNext}
              onSubmit={onSubmit}
            />
          </>
        ) : (
          <div className="text-center py-4">
            <p className="text-muted-foreground">No question available</p>
          </div>
        )}
      </div>
    </Card>
  );
};
